export const i18n = {
  defaultLocale: "en",
  locales: ["en", "ar"],
  rtlLocales: ["ar"],
};
